import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {PopoverController, IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-language-list',
  imports: [IonicModule, TranslateModule],
  templateUrl: './language-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./language-list.component.scss']
})
export class LanguageListComponent {
  @Input() currentLanguage: string;
  @Input() availableLanguages: string[];
  @Output() readonly changeCurrentLanguage = new EventEmitter<string>();

  constructor(private readonly popoverController: PopoverController) {
  }

  changeLanguage(language: string): void {
    this.changeCurrentLanguage.emit(language);
    this.popoverController.dismiss().then();
  }
}
